import React from 'react';

/**
 * Centered "nothing here" panel.
 *   <EmptyState title="No pages yet" message="Create one to get started." action={<Link className="btn btn-primary" to="/new">New page</Link>} />
 */
export default function EmptyState({ title, message, action }) {
  return (
    <div className="empty-state">
      {title && <h3>{title}</h3>}
      {message && <p>{message}</p>}
      {action}
    </div>
  );
}
